import getMessage from 'src/background/utils/i18n.utils';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { Screen } from '@reference-data/screen.enum';
import moment from 'moment';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CustomTooltip } from 'src/common-ui/custom-tooltip/custom-tooltip.component';
const PendingConversionPage = ({ navParams, setTitleContainerProperties, }) => {
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_pending_currency',
            titleParams: navParams.currency,
            isBackButtonEnabled: true,
        });
    }, []);
    return (React.createElement("div", { className: "pending-conversion-page", "data-testid": `${Screen.PENDING_CONVERSION_PAGE}-page` },
        React.createElement("div", { className: "list-panel" },
            React.createElement("div", { className: "list" }, navParams.pendingConversions.map((pendingConversion) => (React.createElement(CustomTooltip, { dataTestId: "tooltip-timesteamp-pending-conversion", position: "bottom", key: pendingConversion.id, message: getMessage('popup_html_pending_currency_timestamp', [
                    moment
                        .utc(pendingConversion.conversion_date)
                        .local()
                        .format('L'),
                    moment
                        .utc(pendingConversion.conversion_date)
                        .local()
                        .format('LT'),
                ]), skipTranslation: true },
                React.createElement("div", { className: "pending-conversion" },
                    React.createElement("div", { className: "expiration-date" }, moment
                        .utc(pendingConversion.conversion_date)
                        .local()
                        .format('L')),
                    React.createElement("div", { className: "amount" }, pendingConversion.amount),
                    ' '))))))));
};
const mapStateToProps = (state) => {
    return {
        navParams: state.navigation.stack[0].params,
    };
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
});
export const PendingConersionPageComponent = connector(PendingConversionPage);
